import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper'
import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import * as SmoothScroll from 'smooth-scroll'

gsap.registerPlugin(ScrollTrigger);
Swiper.use([Navigation, Pagination, Autoplay, EffectFade])
export default function index(){

  const firstAnimation = document.querySelectorAll('.firstAnimation')
  firstAnimation.forEach((el) => {
    el.classList.add('firstActive')
  })

  const swiperParams = {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    grabCursor: true,
    breakpoints: {
      1119: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
    }
  }

  const servicePicSlideParams = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    effect: 'fade',
    crossFade: true,
    speed: 1000,
    autoplay: {
      delay: 4000
    },
    pagination: {
      el: '.servicePicSlidePager',
      clickable: true,
    },
  }
  const swiper = new Swiper('#topicsSlides', swiperParams)
  const servicePicSlide = new Swiper('#servicePicSlide', servicePicSlideParams)
  
  const firstview = document.getElementById('firstview')
  const firstMain = document.getElementById('firstMain')
  const firstPic = document.getElementById('firstPic')
  if(firstPic && firstview && firstMain){
    gsap.fromTo(firstPic,
      {},
      {
        top: '0%',
        scrollTrigger: {
          trigger: firstview,
          start: "top top",
          end: "bottom top+=25%",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
    gsap.fromTo(firstMain,
      {},
      {
        top: '150%',
        opacity: 0,
        scrollTrigger: {
          trigger: firstview,
          start: "top top",
          end: "bottom top+=25%",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
    gsap.fromTo(firstPic,
      {},
      {
        opacity: 0,
        scrollTrigger: {
          trigger: firstview,
          start: "top top-=25%",
          end: "bottom top+=25%",
          scrub: 1,
          once: false,
          //markers: true,
          invalidateOnRefresh: true,
        }
      }
    )
  }


  const firstContent = document.getElementById('firstContent')
  const vcSection = document.getElementById('vcSection')
  if(firstContent){
    ScrollTrigger.create({
      trigger: vcSection,
      pin: firstContent,
      pinSpacer: false,
      pinSpacing: false,
      //markers: true,
      start: "top bottom",
      end: "bottom bottom",
      invalidateOnRefresh: true,
    });
    gsap.fromTo(firstContent,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: firstContent,
          start: "top bottom",
          end: "top center",
          scrub: 1,
          once: false,
          //markers: true,
        }
      }
    )
  }



  const vcSectionSlides = document.getElementById('vcSectionSlides')
  if(vcSection){
    ScrollTrigger.create({
      trigger: vcSection,
      pin: vcSectionSlides,
      //markers: true,
      start: "top top",
      end: "bottom bottom",
      invalidateOnRefresh: true,
      id: 'indexPin',
    });


    gsap.utils.toArray('.vcSection__over').forEach((el, index) => {
      ScrollTrigger.create({
        trigger: vcSection,
        pin: el,
        //markers: true,
        start: "top top",
        end: "bottom bottom",
        invalidateOnRefresh: true,
      });
    })

    const vcSectionBoxVcPic = document.querySelectorAll('.vcSection__box__vc__pic')
    gsap.utils.toArray('.vcSection__pos').forEach((el, index) => {
      gsap.fromTo(vcSectionBoxVcPic[index],
        {
        },
        {
          transform: 'translateX(0rem)',
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: "top bottom-=25%",
            scrub: 2,
            once: false,
            //markers: true,
          }
        }
      )
    })
  }

  if(vcSectionSlides){
    gsap.fromTo(vcSectionSlides,
      {
      },
      {
        left: '-300vw',
        scrollTrigger: {
          trigger: vcSection,
          start: "top top-=50%",
          end: "bottom bottom+=50%",
          scrub: 2,
          once: false,
        }
      }
    )
  }

  const progressBar = document.getElementById('progressBar')
  if(progressBar){
    gsap.fromTo(progressBar,
      {
      },
      {
        width: '100%',
        scrollTrigger: {
          trigger: vcSection,
          start: "top top-=50%",
          end: "bottom bottom+=50%",
          scrub: 2,
          once: false,
        }
      }
    )
  }

	let follower = document.getElementById('follower');
	let c = document.querySelectorAll(".clickable");
	if(follower){
		let
			fWidth = 80,
			delay = 10,
			mouseX = 0,
			mouseY = 0,
			posX = 0,
			posY = 0;

		TweenMax.to({}, .01, {
			repeat: -1,
			onRepeat: function() {
				posX += (mouseX - posX) / delay;
				posY += (mouseY - posY) / delay;
				TweenMax.set(follower, {
					css: {
						left: posX - (fWidth / 2),
						top: posY - (fWidth / 2)
					}
				});
			}
		});
		document.body.addEventListener("mousemove", function(e){
			mouseX = e.clientX;
			mouseY = e.clientY;
		});
		
		for (let i = 0; i < c.length; i++) {
		  c[i].removeEventListener("mouseenter",mouseEnter);
		  c[i].removeEventListener("mouseleave",mouseLeave);
		  c[i].addEventListener("mouseenter",mouseEnter);
		  c[i].addEventListener("mouseleave",mouseLeave);
		}
		
		function mouseEnter(){
			follower.classList.add('active');
		}
		function mouseLeave(){
			follower.classList.remove('active');
		}
	}

  window.addEventListener('load', (indexPin) => {
    var indexPin = ScrollTrigger.getById('indexPin');
    indexPin.refresh()
  });

  window.addEventListener('resize', (indexPin) => {
    var indexPin = ScrollTrigger.getById('indexPin');
    indexPin.refresh()
  });
}